import { render, staticRenderFns } from "./tasksSection.vue?vue&type=template&id=62c6704a&scoped=true&"
import script from "./tasksSection.vue?vue&type=script&lang=js&"
export * from "./tasksSection.vue?vue&type=script&lang=js&"
import style0 from "./tasksSection.vue?vue&type=style&index=0&id=62c6704a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c6704a",
  null
  
)

export default component.exports